export default "__VITE_PUBLIC_ASSET__f43e254d__"